export const ITEMS_PER_PAGE = 15;
export const RECORDING_INDEX_STORAGE_KEY = 'recordingIndex';
export const SEARCH_CONTEXT_STORAGE_KEY = 'recordingSearchContext';
export const RECORDINGS_FRAGMENT_STORAGE_KEY = 'recordingsFragment';
export const RECORDINGS_LIST_STORAGE_KEY = 'recordingsList';
export const RECORDING_ID_STORAGE_KEY = 'recordingId';
export const WATCH_RECORDINGS_IDS_LIST_STORAGE_KEY = 'watchRecrodingsIdsList';
export const PLAYLIST_TOGGLE_PREFERENCE_KEY = 'playlistTogglePreference';

// We'll start loading more recordings when the user's reaches the margin (the n-th recording from the end or the beginning)
export const LOAD_MORE_ITEMS_MARGIN = 1;

export const API_ROOT_V3 = '/api/v3/sites';
